import { Component, Input, OnInit } from '@angular/core';
import { environment } from './../../../../environments/environment';

@Component({
	selector: 'app-cig-create-your-collaboration-profile',
	templateUrl: './cig-create-your-collaboration-profile.component.html',
	styleUrls: ['./cig-create-your-collaboration-profile.component.scss']
})
export class CigCreateYourCollaborationProfileComponent implements OnInit {

	@Input() author;
	@Input() slides;
	public env;
	constructor() { }

	ngOnInit() {
		this.env=environment;
	}

}
